module.exports = __webpack_public_path__ + "effaca7f8cbcbe5cc2a428092b660222.svg";